import { FilterDefinition } from '@app/core/list-view/types';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';
import { GenericSelectFilter } from '../../../../../../core/list-view/base-filters/GenericSelectFilter';
import { GenericTextFilter } from '../../../../../../core/list-view/base-filters/GenericTextFilter';
import { activeOptions, reportTypeOptions, triggerOptions } from './types';

// Re-export FilterDefinition for convenience
export type { FilterDefinition };

/**
 * Configuration array for all AOD Rules List filters.
 * To add a new filter, simply add a new entry here with the component and props.
 * The FacetedFilterBar will automatically render it based on this configuration.
 * Uses default Props generic so both GenericTextFilter and GenericSelectFilter (which require extra props like options) type-check.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- heterogeneous array: some components need extra props (e.g. GenericSelectFilter.options)
export const AOD_RULES_FILTERS_CONFIG: FilterDefinition<any, string>[] = [
  {
    name: 'name||$contL',
    label: defineMessage({
      id: 'audit.aod.rules.field.name',
      defaultMessage: 'Nombre',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      sx: {
        width: '18ch',
      },
    },
  },
  {
    name: 'reportType',
    label: defineMessage({
      id: 'audit.aod.rules.field.reportType',
      defaultMessage: 'Tipo de reporte',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericSelectFilter,
    componentProps: {
      options: reportTypeOptions,
      sx: {
        minWidth: '20ch',
      },
    },
  },
  {
    name: 'trigger',
    label: defineMessage({
      id: 'audit.aod.rules.field.trigger',
      defaultMessage: 'Trigger',
    }),
    parser: parseAsString,
    isPermanent: false,
    component: GenericSelectFilter,
    componentProps: {
      options: triggerOptions,
      sx: {
        minWidth: '16ch',
      },
    },
  },
  {
    name: 'active',
    label: defineMessage({
      id: 'audit.aod.rules.field.active',
      defaultMessage: 'Estado',
    }),
    parser: parseAsString,
    isPermanent: false,
    component: GenericSelectFilter,
    componentProps: {
      options: activeOptions,
      sx: {
        minWidth: '16ch',
      },
    },
  },
];
